import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../services/user.service";
import { ResetPassRequestData } from "../../models/user.model";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent implements OnInit {
  private _fb: FormBuilder = inject(FormBuilder);
  private _userService: UserService = inject(UserService);

  @Input() giPantMode!: boolean;
  @Input() henterPantMode!: boolean;
  @Output() goToLogin: EventEmitter<void> = new EventEmitter<void>;

  form!: FormGroup;
  loading!: boolean;
  error!: boolean;
  errorText!: string | null;
  resultShow: boolean = false;

  constructor() {
    this.formInitialize();
  }

  ngOnInit(): void {
  }

  formInitialize(): void {
    this.form = this._fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (this.loading) return;

    this.error = false;
    this.loading = true;
    this.errorText = null;

    if (!this.form.valid) return;
    const formValue = this.form.value;

    const resetPassReqData: ResetPassRequestData = {
      email: formValue.email
    }

    this._userService.resetPass(resetPassReqData).subscribe(result => {
      this.loading = false;

      this.resultShow = true;
    }, error => {
      this.loading = false;
      this.error = true;

      if (error.status === 429) {
        this.errorText = 'Too Many Requests. Try late.'
      } else if (error.status === 404 && error.error?.error.includes('email does not exist')) {
        this.errorText = error.error.error;
      }
    })
  }

  goLoginStage(): void {
    this.goToLogin.emit();
  }
}
